import { encodeImage } from './lib/encode-image';
export default {
  name: 'Images',
  extensions: ['jpeg'],
  encode: encodeImage,
  DEFAULT_OPTIONS: {
    type: 'png'
  }
};
//# sourceMappingURL=image-writer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@loaders.gl/images/dist/esm/image-writer.js
// module id = 989
// module chunks = 0